module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showCollapse) ? _c('div', {
    class: _vm.hideFieldOnPrint
  }, [_c('el-collapse', {
    staticClass: "el-collapse-01",
    model: {
      value: (_vm.meuCollapse),
      callback: function($$v) {
        _vm.meuCollapse = $$v
      },
      expression: "meuCollapse"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": _vm.getValue
    }
  }, [_c('template', {
    slot: "title"
  }, [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.getName()) + "\n      ")]), _vm._v(" "), _c('div', [_vm._t("default")], 2)], 2)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a1fa5d72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderCollapse.vue
// module id = 956
// module chunks = 2